import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=476b8105&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=476b8105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b8105",
  null
  
)

export default component.exports